import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { GET_USERS } from "./apiRoutes";

/** Users > Add User (admin): existing users matching on email, mobile or name + address. */
const useOwnerDuplicatesMutation = (queryParams?: UseMutationOptions<any, Error, { data: any }, unknown>) =>
  useMutation({
    mutationFn: async ({ data }: { data: any }) => await axiosAuth.post(`${GET_USERS}/owners/duplicates`, data),
    ...queryParams,
  });

export default useOwnerDuplicatesMutation;
